// extracted by mini-css-extract-plugin
module.exports = {"MyJobs":"MyJobs_MyJobs__2r7-G","MyJobs__child":"MyJobs_MyJobs__child__3VnMc"};